import { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { Bar } from 'react-chartjs-2';
import { checkDatatype, formatGraphPower, roundToNearest } from "../utils/NumberUtils";
import { format } from "date-fns";

const SolarChartLayout = ({ posts, type, isAuto, date }) => {
    const [chart, setChart] = useState({
        max: [50, 1000, 100000],
        step: [10, 100, 10000],
        scale: [(10 * 5), (100 * 5), (10000 * 5)]
    });

    const [label, setLabel] = useState('day');
    const [screenHeight] = useState("28vh");

    useEffect(() => {

        const dayLabel = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];
        const weekLabel = ["11/27(土)", "11/28(日)", "11/29(月)", "11/30(火)", "12/1(水)", "12/2(木)", "12/3(金)"];
        const dateObj = new Date(date);
        const month = dateObj.getMonth();
        const year = dateObj.getFullYear();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthLabel = Array.from({ length: daysInMonth }, (_, i) => String(i + 1));
        const yearLabel = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

        switch (type) {
            case "day": setLabel(dayLabel); break;
            case "week": setLabel(weekLabel); break;
            case "month": setLabel(monthLabel); break;
            case "year": setLabel(yearLabel); break;
            default: return null;
        }
        //eslint-disable-next-line
    }, [type]);

    useEffect(() => {
        // const max1 = parseFloat(Math.max(...posts.radiation)) + 5;
        // const max2 = parseFloat(Math.max(...posts.temperature)) + 5;
        // const max3 = parseFloat(Math.max(...posts.generation)) + 5;
        const max1 = parseFloat(Math.max(...(checkData(posts.solar_radiation)))) + 5;
        const max2 = parseFloat(Math.max(...(checkData(posts.temperature)))) + 5;
        const max3 = parseFloat(Math.max(...(checkData(posts.power_gene_str)))) + 5;


        let maxVal = 40000;

        if (isAuto) {
            maxVal = parseFloat(Math.max(max1, max2, max3)) - 5;

            if (type === 'day') {
                maxVal = 40000
            } else if (type === 'week') {
                maxVal = 600000
            } else if (type === 'month') {
                maxVal = 600000
            } else {
                maxVal = 10000000
            }
            const stepVal = parseInt(Math.round((maxVal) / 5));
            const step1 = parseInt(Math.round(max1 / 5));
            const step2 = parseInt(Math.round(max2 / 5));

            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5]
            });
        } else {
            const maxVal = parseFloat(Math.max(max1, max2, max3)) - 5;
            let final = maxVal > 100000 && maxVal < 1000000 ? roundToNearest(maxVal, 250000) : maxVal > 1000000 && maxVal < 10000000 ? roundToNearest(maxVal, 2500000) : maxVal > 10000000 && maxVal < 100000000 ? roundToNearest(maxVal, 25000000) : maxVal > 100000000 && maxVal < 1000000000 ? roundToNearest(maxVal, 250000000) : roundToNearest(maxVal + 5, 25000)
            const stepVal = parseInt(Math.round((final) / 5));
            const step1 = type === 'day' ? roundToNearest(parseInt(Math.round(max1 / 5)), 100) : type === 'month' ? roundToNearest(parseInt(Math.round(max1 / 5)), 1000) : roundToNearest(parseInt(Math.round(max1 / 5)), 10000);
            const step2 = roundToNearest(parseInt(Math.round(max2 / 5)), 10);
            setChart({
                step: [step1, step2, stepVal],
                scale: [step1 * 5, step2 * 5, stepVal * 5],
            });
        }//eslint-disable-next-line
    }, [isAuto, posts]);

    if (posts === null) {
        return null;
    };
    const legendMargin = {
        beforeInit(chart) {
            const originalFit = chart.legend.fit;
            chart.legend.fit = function fit() {
                originalFit.bind(chart.legend)();
                this.height += 20;
            }
        },
        // afterInit(chart) {
        //     const originalFit = chart.legend.fit;
        //     chart.legend.fit = function fit() {
        //         originalFit.bind(chart.legend)();
        //         this.width += 200;
        //     }
        // }
    }

    const checkData = (values) => {
        let newValue = [];
        for (let i = 0; i < values.length; i++) {
            if (typeof values[i] === "number") {
                newValue.push(values[i].toFixed(1));

            } else {
                newValue.push(0);
            }
        }
        return newValue;
    }
    return <>
        <Col md={12} className="p-0 graphMaintain" style={{ height: screenHeight }}>
            <Bar
                id="bottom-chart"
                data={{
                    labels: label,
                    datasets: [{
                        type: "line",
                        label: "日射量 [kWh/m²]",
                        fill: false,
                        data: checkData(posts.solar_radiation),
                        borderColor: "#E4D00A",
                        yAxisID: 'y1',
                        pointStyle: 'circle',
                        pointRadius: 3,
                        pointBackgroundColor: "#E4D00A",
                    },
                    {
                        type: "line",
                        label: "温度 [°C]",
                        fill: false,
                        data: checkData(posts.temperature),
                        borderColor: "rgba(255, 147, 30, 1)",
                        yAxisID: 'y2',
                        pointStyle: 'round',
                        pointRadius: 3,
                        pointBackgroundColor: "rgba(255, 147, 30, 1)",
                    },
                    {
                        barPercentage: 0.5,
                        type: "bar",
                        label: '発電量 [kWh]',
                        data: checkDatatype(posts.power_gene_str),
                        backgroundColor: "#008000",
                        borderColor: "#008000",
                    }]
                }}
                options={{
                    resposive: true,
                    maintainAspectRatio: false,
                    animation: true,
                    barPercentage: 0.5,
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    interaction: {
                        intersect: false,
                        mode: "index"
                    },
                    plugins: {
                        tooltip: {
                            //enabled: false,
                            backgroundColor: "#000000",
                            //borderColor: 'rgba(255, 147, 30, 1)',
                            borderWidth: 1,
                            title: { display: false },
                            displayColors: true,
                            boxWidth: 5,
                            boxHeight: 25,
                            caretPadding: 20,
                            // xAlign: 'left',
                            yAlign: "center",
                            bodyFont: { size: 13 },
                            // bodyColor: "black",
                            filter: function (context) {
                                // var label = context.dataset.data[context.dataIndex];
                                // if (label === 0) {
                                //     return false;
                                // } else {
                                return true;
                                // }
                            },
                            callbacks: {
                                title: function (tooltipItems, data) {
                                    //Return value for title
                                    if (type === 'day') {
                                        return `${format(new Date(date), 'yyyy/MM/dd')} ${tooltipItems[0].label}`;
                                    } if (type === 'month') {
                                        return `${format(new Date(date), 'yyyy/MM')}/${tooltipItems[0].label < 10 ? '0' + tooltipItems[0].label : tooltipItems[0].label}`;
                                    }
                                    if (type === 'year') {
                                        return `${format(new Date(date), 'yyyy')}/${tooltipItems[0].label < 10 ? '0' + tooltipItems[0].label : tooltipItems[0].label}`;
                                    }
                                },
                                label: function (context) {
                                    const label = context.dataset.label.split('[')[0].trim();
                                    if (context.dataset.label.includes("[kW")) {
                                        const value = formatGraphPower(context.dataset.data[context.dataIndex], 2)
                                        return `${label} : ${context.dataset.label.includes("/m²") ? value + '/m²' : value} `;
                                    } else {
                                        const regex = /\[(.*?)\]/g;
                                        const matches = [];
                                        let match;
                                        while ((match = regex.exec(context.dataset.label))) {
                                            matches.push(match[1]);
                                        }
                                        return `${label} : ${context.dataset.data[context.dataIndex]}${matches} `;
                                    }
                                },
                            },
                        }, legend: {
                            onClick: (click, legendItem, legend) => {
                                const datasets = legend.legendItems.map((dataset, index) => {
                                    return dataset.text;
                                });
                                const index = datasets.indexOf(legendItem.text);
                                if (legend.chart.isDatasetVisible(index) === true) {
                                    legend.chart.hide(index);
                                } else {
                                    legend.chart.show(index);
                                }
                            },
                            labels: {
                                // padding: 20,
                                usePointStyle: true,
                                generateLabels: (chart) => {
                                    let visibility = [];
                                    for (let i = 0; i < chart.data.datasets.length; i++) {
                                        if (chart.isDatasetVisible(i) === true) {
                                            visibility.push(false);

                                        } else {
                                            visibility.push(true);
                                        }
                                    }
                                    let pointStyle = [];
                                    chart.data.datasets.forEach(dataset => {
                                        if (dataset.type === 'line') {
                                            pointStyle.push('line')

                                        }
                                        else {
                                            pointStyle.push('rect');
                                        }
                                    });
                                    return chart.data.datasets.map(
                                        (dataset, index) => ({
                                            text: dataset.label,
                                            fillStyle: dataset.backgroundColor,
                                            strokeStyle: dataset.borderColor,
                                            lineWidth: 3,
                                            pointStyle: pointStyle[index],
                                            hidden: visibility[index],
                                            // legendMargin: 5

                                        })
                                    )
                                }
                            },

                        },
                    },
                    scales: {
                        y: {
                            min: 0,
                            max: chart.scale[2],
                            stacked: true,
                            grid: { display: true, borderColor: '#000000' },
                            ticks: {
                                stepSize: chart.step[2],
                                autoSkip: false,
                                maxTicksLimit: 6,
                                callback: (val, type) => {
                                    if (val === 0) {
                                        return "0";
                                    }
                                    // else if (val > 999999) {
                                    //     const newVal = val / 1000000;
                                    //     return newVal.toFixed(1) + 'M';
                                    // }
                                    else {
                                        return Math.round(val / 1000) + 'K';
                                    }
                                },
                                color: "#000000"
                            },
                            display: true,
                            position: 'left'
                        },
                        y1: {
                            min: 0,
                            max: chart.scale[0],
                            display: true,
                            position: 'left',
                            stacked: false,
                            grid: { display: false, borderColor: '#000000' },
                            ticks: {
                                stepSize: chart.step[0],
                                autoSkip: false,
                                maxTicksLimit: 6,
                                callback: (val) => {
                                    if (val === 0) {
                                        return "0";
                                    }
                                    // else if (val > 999999) {
                                    //     const newVal = val / 1000000;
                                    //     return newVal.toFixed(1) + 'M';
                                    // }
                                    else if (val > 999) {
                                        const newVal = val / 1000;
                                        return newVal + 'K';
                                    } else {
                                        return val;
                                    }
                                },
                                color: "#000000"
                            },
                        },
                        y2: {
                            beginAtZero: true,
                            max: chart.scale[1],
                            display: true,
                            position: 'left',
                            stacked: false,
                            grid: { display: false, borderColor: '#000000' },
                            ticks: {
                                stepSize: chart.step[1],
                                autoSkip: false,
                                maxTicksLimit: 6,
                                callback: (val) => {
                                    if (val === 0) {
                                        return "0";
                                    } else {
                                        return val;
                                    }
                                },
                                color: "#000000"
                            },

                        },
                        x: { grid: { display: true, borderColor: '#000000' }, stacked: true, ticks: { color: "#000000" } },
                    },
                    color: "#000000"
                }}
                plugins={[legendMargin, {
                    afterDraw: function (chart, easing) {
                        if (chart.tooltip._active && chart.tooltip._active.length) {
                            const activePoint = chart.tooltip._active[0];
                            const ctx = chart.ctx;
                            const x = activePoint.element.x;
                            const topY = chart.scales.y.top;
                            const bottomY = chart.scales.y.bottom;


                            // Check if activePosition is greater than 10
                            const reposition = type === 'day' ? 13 : type === "month" ? 18 : 7;
                            if (activePoint.index >= reposition) {
                                chart.tooltip.options.xAlign = 'right'; // Change xAlign to 'left'
                                // chart.tooltip.options.yAlign = 'right'; // Change xAlign to 'left'
                            } else {
                                chart.tooltip.options.xAlign = 'left'; // Reset xAlign to 'center' (default)
                                // chart.tooltip.options.yAlign = 'left'; // Reset xAlign to 'center' (default)
                            }

                            // Draw Vertical Line
                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(x, topY);
                            ctx.lineTo(x, bottomY);
                            ctx.lineWidth = 2;
                            ctx.strokeStyle = '#000';
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                }]}
            />
            <span className="scale-text graph2-text">°C</span>
            <span className="scale-text graph2-text ml-3">Wh/m²</span>
            <span className="scale-text graph2-text pl-4">Wh</span>
        </Col>
    </>;
};

export default SolarChartLayout;